export default __webpack_public_path__ + "static/media/heart.16282a64.svg";